import {
  getImportTableOverrideStyle,
} from '@bingads-webui-campaign-react/imports-shared-styles';

export const getImportsCommonStyle = ({ palette = {} }) => ({
  '& .description-content': {
    marginTop: 20,
    marginLeft: 5,
  },
  '& .page-title-header-placeholder-alert': {
    marginTop: 10,
    '& a': {
      color: '#006ed4',
    },
  },
  '&>.section-title': {
    '&>.page-title': {

      '&>*': {
        padding: [0, 32, 0, 32],
      },

      '&>h1': {
        fontSize: 26,
        padding: [0, 32, 18, 32],
        borderBottom: `1px solid ${palette.neutralLighter}`,
      },
    },

    '&>.form-group': {
      padding: [13, 32, 0, 32],
    },
  },

  '&>.section-body': {
    '& .toolbar': {
      '& #refresh_log, & #refresh_schedule, & #upload_file': {
        padding: [16, 8],
        height: 56,
        border: 'none',
      },

      '& .navbar-nav': {
        margin: 0,
      },
    },

    '& .ba-backbone-instance-wrapper': {
      marginLeft: 32,
      marginRight: 32,
    },
  },

  ...getImportTableOverrideStyle({ palette }),
});
